import { capitalize, markRaw } from 'vue';

import { IconColoredCampaign, IconColoredDeal, IconColoredLineItem, IconColoredScreen } from '@/common/icons/colored';
import rootState from '@/store/state';
import i18n from '@/vueI18n';

export interface IOrganizationCustomFieldTypeOption {
  value: string;
  name: string;
  icon: any;
}

class OrganizationCustomFieldTypeOptions {
  static options(): IOrganizationCustomFieldTypeOption[] {
    return [
      {
        value: 'campaign',
        name: capitalize(i18n.global.t('names.campaign', { n: 1 })),
        icon: markRaw(IconColoredCampaign),
      },
      {
        value: 'lineitem',
        name: capitalize(i18n.global.t('names.lineItem', { n: 1 })),
        icon: markRaw(IconColoredLineItem),
      },
      {
        value: 'package',
        name: capitalize(i18n.global.t('names.deal', { n: 1 })),
        icon: markRaw(IconColoredDeal),
      },
      ...(rootState?.orgApp?.organization?.isDemandOrganization
        ? []
        : [
            {
              value: 'unit',
              name: capitalize(i18n.global.t('names.unit', { n: 1 })),
              icon: markRaw(IconColoredScreen),
            },
          ]),
    ];
  }

  static get Campaign() {
    return OrganizationCustomFieldTypeOptions.options().find((x) => x.value === 'campaign');
  }

  static get LineItem() {
    return OrganizationCustomFieldTypeOptions.options().find((x) => x.value === 'lineitem');
  }

  static get Deal() {
    return OrganizationCustomFieldTypeOptions.options().find((x) => x.value === 'package');
  }

  static get Unit() {
    return OrganizationCustomFieldTypeOptions.options().find((x) => x.value === 'unit');
  }

  static fromValue(value: string) {
    return OrganizationCustomFieldTypeOptions.options().find((x) => x.value === value);
  }
}

export default OrganizationCustomFieldTypeOptions;
